import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../primaryComponents";
import { defaultDateDisplay } from "../../../../helpers";
import secondaryComponents from "../..";
import { useGetPurchaseOrderDetails } from "../../../../hooks/api/queries";
import { DownloadIcon, SendIcon } from "../../../../assets/svgIcons";
import { usePOShareDialog } from "./usePOShareDialog";
import { RoutedModal } from "../../../common";
import { useState } from "react";
import { POSendEmail } from "../POSendEmail";

export const POShareDialog = ({ POId, closeModal = () => {} }) => {
  const [isSendEmail, setIsSendEmail] = useState(false);
  const { data: PODetails, isLoading: isLoadingPODetails } =
    useGetPurchaseOrderDetails({ id: POId });

  const { isDownlaodingPo, handleDownloadPO } = usePOShareDialog({
    closeModal,
  });

  return (
    <div>
      <h5 className="font-weight-normal">PO Detail</h5>

      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoadingPODetails}
      >
        <div
          className={`${globalStyles.cardWithBorder} ${globalStyles.gridDetailsView}`}
          style={{
            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          }}
        >
          <div>
            <p>PO Number:</p>
            <p className="dark--text">{PODetails?.po_number || "N/A"}</p>
          </div>
          <div>
            <p>Supplier:</p>
            <p className="dark--text">{PODetails?.supplier?.name || "N/A"}</p>
          </div>
          <div>
            <p>Created by</p>
            <p className="dark--text">
              {PODetails?.po_date
                ? defaultDateDisplay(PODetails?.po_date)
                : "N/A"}
            </p>
          </div>
        </div>

        <div className="d-flex mt-4" style={{ gap: "10px" }}>
          <primaryComponents.Button
            classNames={"btn btn--outline cover"}
            onClick={() => setIsSendEmail(true)}
          >
            <SendIcon className="mr-2" />
            Send To Supplier
          </primaryComponents.Button>

          <primaryComponents.Button
            classNames={"btn btn--primary cover"}
            onClick={() => handleDownloadPO(PODetails)}
            disabled={isDownlaodingPo}
            isDisabled={isDownlaodingPo}
            isLoading={isDownlaodingPo}
            loadingText={"Downloading..."}
          >
            <DownloadIcon className="mr-2" /> Download
          </primaryComponents.Button>
        </div>
      </secondaryComponents.LoaderHelper>

      <RoutedModal
        width={550}
        leftHeaderSide={<h4>Send P.O to supplier</h4>}
        isActive={isSendEmail}
        closeModal={() => setIsSendEmail(false)}
        style={{ height: "auto" }}
      >
        <POSendEmail
          pODetails={PODetails}
          closeModal={() => {
            setIsSendEmail(false);
            closeModal();
          }}
        />
      </RoutedModal>
    </div>
  );
};
